import "@vuepic/vue-datepicker/dist/main.css"
import "./styles/global.scss"

import Notifications from "@/plugins/notifications.plugin"
import { UniqueComponentId } from "@ekkosense/client-framework"
import VueDatePicker from "@vuepic/vue-datepicker"
import { createPinia } from "pinia"
import VTooltip from "v-tooltip"
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"

createApp(App)
    .use(createPinia())
    .use(router)
    .use(Notifications)
    .use(VTooltip)
    // The following is also confirmed at runtime
    .use(UniqueComponentId, {disable: process.env.NODE_ENV != "development"})
    .component('VueDatePicker', VueDatePicker)
    .mount('#app')
